module.exports = __webpack_public_path__ + "img/invitations_nav.de1aa0a6.jpg";